import Is from 'core/utility/is'
import React from 'react'
import {Route} from '../types'
import {Outlet} from 'react-router-dom'

type MiddlewareProps = {
  layout: any
}

export default function ParentMiddleware(props: MiddlewareProps) {
  const {
    layout: {LayoutComponent, middleware},
  } = props

  if (!Is.empty(middleware)) {
    const middlewareList: any = Is.array(middleware) ? middleware : [middleware]

    for (let middleware of middlewareList as Function[]) {
      const output = middleware()

      if (output) {
        return output
      }
    }
  }

  return (
    <LayoutComponent>
      <Outlet />
    </LayoutComponent>
  )
}
